/*
 * Authentication API
 */
export const AUTH_API = '/auth';

export const AUTH_LOGIN_ENDPOINT = `${AUTH_API}/login`;
export const AUTH_REQUEST_OTP_ENDPOINT = `${AUTH_API}/request-otp`;
export const AUTH_VERIFY_OTP_ENDPOINT = `${AUTH_API}/verify-otp`;
export const AUTH_REQUEST_OTP_RESET_PASSWORD_ENDPOINT = `${AUTH_API}/request-reset-password-otp`;
export const AUTH_RESET_PASSWORD_ENDPOINT = `${AUTH_API}/reset-password`;
export const AUTH_REFRESH_TOKENS_ENDPOINT = `${AUTH_API}/refresh-tokens`;
export const AUTH_LOGOUT_ENDPOINT = `${AUTH_API}/logout`;

/*
 * Charge points API
 */
export const CHARGE_POINT_API = '/charge-points';

/*
 * Customers API
 */
export const CUSTOMER_API = '/customers';

/*
 * Customers API
 */
export const CHARGE_POINT_SUBSCRIPTION = '/charge-point-subscriptions';

/*
 * Users API
 */
export const USER_API = '/users';
export const USER_ME_ENDPOINT = `${USER_API}/me`;
export const USER_ME_PASSWORD_ENDPOINT = `${USER_ME_ENDPOINT}/password`;
export const USER_ME_PREFERENCES_ENDPOINT = `${USER_ME_ENDPOINT}/preferences`;

/*
 * Roles API
 */
export const ROLE_API = 'roles';

/*
 * Role templates API
 */
export const ROLE_TEMPLATE_API = 'role-templates';

/*
 * Locations API
 */
export const LOCATION_API = '/locations';

/*
 * Networks API
 */
export const NETWORK_API = '/networks';

/*
 * Tarriff API
 */
export const TARIFF_ENDPOINT = '/tariffs';

/*
 * Tickets API
 */
export const TICKET_API = '/tickets';

/*
 * EMSP Users API
 */
export const EMSP_USER_API = '/emsp-bo/emsp-users';

/*
 * Transactions API
 */
export const TRANSACTION_API = '/transactions';
